<template>
  <div>

    <HeroBanner
      heading="Bid with confidence"
      subheading="The PFX platform provides qualified buyers equal opportunity to purchase real estate via a real-time online auction with price transparency."
      theme="buyer"
      :image="require('../assets/buyers-hero.jpg')"
      :buttons="['start-bidding']"
    />

    <div class="split-view clearfix">
      <div class="column text-padding">
        <h2>Go from initial interest in a property to close of escrow, easily.</h2>
        <ul class="icons">
          <li><v-icon color="brand">check</v-icon> Access auctions from broker listings or search PFX</li>
          <li><v-icon color="brand">check</v-icon> Complete due diligence easily</li>
          <li><v-icon color="brand">check</v-icon> Get approved to bid</li>
          <li><v-icon color="brand">check</v-icon> Monitor auction activity in real-time</li>
          <li><v-icon color="brand">check</v-icon> Place your bid and win the auction</li>
          <li><v-icon color="brand">check</v-icon> Execute purchase agreement and proceed to close</li>
        </ul>
      </div>
      <div class="column image-padding easy-image">
      </div>
    </div>

    <div class="split-view clearfix">
      <div class="split-view-1">
        <div class="column text-padding">
          <h2>Find and register for property auctions</h2>
          <p>
            Access PFX-powered auctions directly from the listing agent's website or through PFX.com.
            To participate in an auction, complete your application and wait for approval to bid.
          </p>
        </div>
        <div class="column find-auctions-image">
          <div class="image-padding image-overlay">
            <img :src="require('../assets/screenshot-auction-page.png')" />
          </div>
        </div>
      </div>

      <div class="split-view-2">
        <div class="column due-diligence-image">
          <div class="image-padding image-overlay">
            <img :src="require('../assets/screenshot-docvault.png')" />
          </div>
        </div>
        <div class="column text-padding">
          <h2>Perform all due diligence before bidding begins</h2>
          <p>
            With PFX, all qualified buyers complete due diligence prior to the auction start.
            Review broker-provided documents, arrange inspections and set up viewings with
            the broker during the registration period.
          </p>
        </div>
      </div>

      <div class="split-view-3">
        <div class="column text-padding">
          <h2>Monitor your auctions and control your bids</h2>
          <p>
            Once an auction starts, you can monitor bidding in real-time via your dashboard.
            Set up automatic bidding so you never miss an opportunity to outbid competitors.
            Specify bid increments and your maximum price for each auction.
          </p>
        </div>
        <div class="column monitor-dashboard-image">
          <div class="image-padding image-overlay">
            <img :src="require('../assets/screenshot-monitor-buyer.png')" />
          </div>
        </div>
      </div>
    </div>

    <div class="container why-pfx">
      <h2 class="align-center">What to Expect</h2>
      <div class="clearfix columns">
        <div class="three-column">
          <div><img :src="require('../assets/why-secure.svg')"/></div>
          <h3>Secure Document Sharing</h3>
          <p>
            PFX's Document Vault consolidates all due diligence documents related to an auction for review.
            Upload your qualification documents securely for listing agent/seller approval.
          </p>
        </div>
        <div class="three-column">
          <div><img :src="require('../assets/why-sales.svg')"/></div>
          <h3>Seamless Sales Process</h3>
          <p>
            From registration and due diligence review to winning the auction,
            all key tasks are handled through PFX — simplifying the sales process while providing transparency.
          </p>
        </div>
        <div class="three-column">
          <div><img :src="require('../assets/why-transaction.svg')"/></div>
          <h3>Hassle-free Transaction</h3>
          <p>
            Once the auction closes, the highest bidder wins and signs the purchase agreement to open
            escrow — no more multiple counter offers or blindly submitting "highest and best price."
          </p>
        </div>
      </div>
    </div>

    <div class="call-to-action-1 align-center">
      <h2>Sign-up to start bidding!</h2>
      <button class="btn-rounded fat" @click="$store.commit('openSignUpDialog')">Sign-up to start bidding</button>
    </div>

    <div class="videos clearfix" v-if="hideVideos">
      <div class="column video1">
        <h2>Watch PFX Videos to learn more</h2>
      </div>
      <div class="column video2 pointer" @click="$store.commit('openYouTubeDialog', 'E5yFcdPAGv0')"><!-- TODO change video -->
        <div class="title">Get Started <div class="length">5:40</div></div>
        <div class="play" @click="$store.commit('openYouTubeDialog', 'drIRh_YOS1E')"></div>
      </div>
      <div class="column video3 pointer" @click="$store.commit('openYouTubeDialog', 'HyHNuVaZJ-k')"><!-- TODO change video -->
        <div class="title">Create Listing <div class="length">8:00</div></div>
        <div class="play" @click="$store.commit('openYouTubeDialog', 'drIRh_YOS1E')"></div>
      </div>
      <div class="column video4 pointer" @click="$store.commit('openYouTubeDialog', 'GgwE94KZJ7E')"><!-- TODO change video -->
        <div class="title">Approve Bidding <div class="length">4:32</div></div>
        <div class="play"></div>
      </div>
    </div>

    <div class="container faq-section">
      <h2>Get answers to commonly asked questions</h2>
      <FaqBuyers :embed="true" />
    </div>

  </div>
</template>

<script>
  import HeroBanner from './elements/HeroBanner.vue'
  import FaqBuyers from './FaqBuyers.vue'

  export default {
    name: 'AboutBuyers',
    components: {
      HeroBanner,
      FaqBuyers
    },
    data() {
      return {
        videoDialog1: false,
        videoDialog2: false,
        videoDialog3: false,
        hideVideos: process.env.config.frontend.hideVideos
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  .easy-image {
    background-image: url('../assets/buyers-building.jpg');
    background-size: cover;
    background-position: center;
    height: 543px;
  }

  .split-view-1 {
    .text-padding {
      background-color: #1B292E;
      color: #fff;
      height: 676px;
      padding: 200px 60px 40px;
    }
    .image-padding {
      height: 676px;
    }
    h2 {
      margin-bottom: 40px;
    }
  }

  .split-view-2 {
    .text-padding {
      background-color: #11758F;
      color: #fff;
      height: 676px;
      padding: 200px 60px 40px;
    }
    .image-padding {
      height: 676px;
    }
    h2 {
      margin-bottom: 30px;
    }
  }

  .split-view-3 {
    .text-padding {
      background-color: #1B292E;
      color: #fff;
      height: 676px;
      padding: 200px 60px 40px;
    }
    .image-padding {
      height: 676px;
    }
    h2 {
      margin-bottom: 30px;
    }
  }

  .find-auctions-image {
    background-color: #E9E9E9;
  }
  .due-diligence-image {
    background-color: #fff;
  }
  .monitor-dashboard-image {
    background-color: #E9E9E9;
  }
  .image-overlay {
    background-color: rgba(#fff, .5);
    width: 100%;
    height: 100%;
    text-align: center;
    img {
      padding: 55px;
      max-width: 100%;
      max-height: 100%;
    }
  }

  .why-pfx {
    padding: 100px 50px;

    h2 {
      font-family: 'Encode Sans', sans-serif;
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 59px;
    }
    .columns {
      padding: 0 0 2em;
      text-align: center;
      img {
        height: 60px;
      }
    }
    h3 {
      font-family: 'Encode Sans', sans-serif;
      font-weight: 600;
      font-size: 16px;
    }
    p {
      font-size: 16px;
    }
  }

  .call-to-action-1 {
    margin: 0 auto;
    padding: 41px 0 55px;
    background-color: #1B292E;
    background-image: url('../assets/signup-banner.svg');
    background-size: cover;
    background-position: bottom left;
    color: #fff;
    text-shadow: 2px 2px 2px #000;
  }

  .faq-section {
    padding: 100px 40px 120px;
    h2 {
      font-family: 'Encode Sans', sans-serif;
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 50px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AboutBuyers.vue